export class ApplicationSubmission {
  professions: number[] = [];
  qualifications: number[] = [];
  paymentFormId: number;
  grantTypeId: number;
  studyFormId: number;
  educatedId: number;
  departmentId: number;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/application-submission.ts